import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Clock, Brain, TrendingUp, ShieldCheck } from 'lucide-react';
export function BenefitsSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  const benefits = [{
    icon: <Clock className="w-8 h-8 text-[#00A3FF]" data-id="element-26" />,
    title: 'Ahorrá horas de estudio',
    desc: 'Dejá de perder tiempo resumiendo mal o buscando métodos. Aplicá sistemas probados que te permiten aprender más rápido.',
    color: 'rgba(0, 163, 255, 0.1)',
    borderColor: 'rgba(0, 163, 255, 0.3)'
  }, {
    icon: <Brain className="w-8 h-8 text-[#9D4EDD]" data-id="element-27" />,
    title: 'Chau estrés y ansiedad',
    desc: 'Tené todo bajo control desde el primer día. Saber exactamente qué estudiar y cuándo te da paz mental.',
    color: 'rgba(157, 78, 221, 0.1)',
    borderColor: 'rgba(157, 78, 221, 0.3)'
  }, {
    icon: <TrendingUp className="w-8 h-8 text-[#00C853]" data-id="element-28" />,
    title: 'Mejorá tus notas',
    desc: 'No se trata de ser un genio, sino de estudiar de forma estratégica. Aumentá tu rendimiento académico sin quemarte.',
    color: 'rgba(0, 200, 83, 0.1)',
    borderColor: 'rgba(0, 200, 83, 0.3)'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-[#FF6D00]" data-id="element-29" />,
    title: 'Confianza en los exámenes',
    desc: 'Llegá a los parciales y finales sintiéndote seguro, sabiendo que dominás los temas y tenés una estrategia clara.',
    color: 'rgba(255, 109, 0, 0.1)',
    borderColor: 'rgba(255, 109, 0, 0.3)'
  }];
  return <section id="beneficios" className="w-full py-24 px-4 relative overflow-hidden bg-transparent" data-id="element-30">
      <div className="max-w-6xl mx-auto flex flex-col items-center relative z-10" data-id="element-31">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-3xl md:text-5xl font-black text-white mb-4 text-center leading-tight" data-id="element-32">
          ¿Por qué necesitas este sistema?
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-textMuted max-w-2xl mb-16 text-center font-medium" data-id="element-33">
          El MegaPack no es solo información, es una transformación completa de
          tu forma de vivir la universidad.
        </motion.p>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full" data-id="element-34">
          {benefits.map((benefit, index) => <motion.div key={index} variants={itemVariants} className="bg-[#130F1C] rounded-3xl p-8 border border-white/5 hover:-translate-y-1 transition-all duration-300 relative overflow-hidden group" data-id="element-35">
              <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" style={{
            background: `radial-gradient(circle at top right, ${benefit.color}, transparent 70%)`
          }} data-id="element-36" />

              <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-6 border" style={{
            backgroundColor: benefit.color,
            borderColor: benefit.borderColor
          }} data-id="element-37">
                {benefit.icon}
              </div>

              <h3 className="text-2xl font-bold text-white mb-4 relative z-10" data-id="element-38">
                {benefit.title}
              </h3>

              <p className="text-textMuted text-lg leading-relaxed relative z-10" data-id="element-39">
                {benefit.desc}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}